export class PasswordRequest {
  constructor (newPassword, passwordConfirmation) {
    this.newPassword = newPassword
    this.passwordConfirmation = passwordConfirmation
  }
}
